import { Interface } from "readline";
import { gliFormLogov2 } from "../../../../../../../assets";
import "./headerSection.css";

interface HeaderProps {
	isPrintable: boolean;
}

// eslint-disable-next-line react/prop-types
const HeaderSection = ({ isPrintable }: HeaderProps) => {
	return (
		<div className="gli-header-container">
			<div className="header-logo">
				<img src={gliFormLogov2} className="gli-logo" alt="Gli Logo" />
				<div className="header-logo-text">
					<p className="gli-sub-header font-size-md">
						<b>Companion Life Insurance</b>
					</p>
					<p className="gli-sub-header1 font-size-md">Company P.O. Box 1535</p>
					<p className="gli-sub-header1 font-size-md"> Dubuque, IA 52004-1535</p>
				</div>
			</div>
			<div className="header-description">
				<p className={isPrintable ? "font-size-13" : "gli-main-header font-size-lg"}>
					<b>BENEFICIARY ELECTION FORM</b>
				</p>
			</div>
		</div>
	);
};

export default HeaderSection;
